import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaSearchInput = Loadable({
  loader: () => import("./SearchInput"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaSearchInput;



// WEBPACK FOOTER //
// ./ecology9/wea-search-input/index.js